
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"750","height":"500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M750 0H0v500","fill":"#009e49"}}),_c('path',{attrs:{"d":"M0 500h750V0","fill":"#ce1126"}}),_c('path',{attrs:{"d":"M0 500L750 0","stroke":"#fcd116","stroke-width":"210"}}),_c('path',{attrs:{"d":"M0 500L750 0","stroke":"#000","stroke-width":"150"}}),_c('g',{attrs:{"id":"c","transform":"rotate(-33.69 514.716 -777.095)","fill":"#fff"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-70V0h35","transform":"rotate(18 0 -70)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(288)"}})]),_c('use',{attrs:{"xlink:href":"#c","transform":"translate(-285 190)"}})])
          )
        }
      }
    